<template>
  <div v-if="isNotProduction" class="demo-only" style="display: contents">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'DemoComponent',
  data() {
    return {
      isNotProduction: process.env.VUE_APP_APP_ENV !== 'production',
    };
  },
};
</script>

<style scoped lang="scss"></style>
